var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            {
              ref: "pram",
              attrs: { "label-position": "top", "label-width": "150px" },
              model: {
                value: _vm.pram,
                callback: function ($$v) {
                  _vm.pram = $$v
                },
                expression: "pram",
              },
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-row",
                    _vm._l(_vm.showList1, function (item, index) {
                      return _c(
                        "el-col",
                        {
                          key: index,
                          attrs: {
                            span: (index + 1) % 2 == 0 ? 12 : 11,
                            offset: (index + 1) % 2 == 0 ? 1 : 0,
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.setName(item.key) } },
                            [
                              _vm.inputList.includes(item.key)
                                ? _c("el-input", {
                                    model: {
                                      value: item.value,
                                      callback: function ($$v) {
                                        _vm.$set(item, "value", $$v)
                                      },
                                      expression: "item.value",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.orList.includes(item.key)
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: { placeholder: _vm.$t("qxz") },
                                          model: {
                                            value: item.status,
                                            callback: function ($$v) {
                                              _vm.$set(item, "status", $$v)
                                            },
                                            expression: "item.status",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("kaiqi"),
                                              value: 1,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("guanbi"),
                                              value: 0,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.czzsms1.includes(item.key)
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: { placeholder: _vm.$t("qxz") },
                                          model: {
                                            value: item.value,
                                            callback: function ($$v) {
                                              _vm.$set(item, "value", $$v)
                                            },
                                            expression: "item.value",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("dcje"),
                                              value: _vm.$t("dcje"),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("ljje"),
                                              value: _vm.$t("ljje"),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "margin_bottom_12" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["roleManager:rewardSetting:add"],
                              expression: "['roleManager:rewardSetting:add']",
                            },
                          ],
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.addItem("czljjeList1")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("tjqtbl")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.czljjeList1, function (sunItem, sunIndex) {
                    return _c(
                      "el-row",
                      { key: sunIndex },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 9 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("zsjedydy") } },
                              [
                                _c(
                                  "el-input",
                                  {
                                    model: {
                                      value: sunItem.condition,
                                      callback: function ($$v) {
                                        _vm.$set(sunItem, "condition", $$v)
                                      },
                                      expression: "sunItem.condition",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("%"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 9, offset: 1 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("zsjebfb") } },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: { type: "number", max: 100 },
                                    model: {
                                      value: sunItem.value,
                                      callback: function ($$v) {
                                        _vm.$set(sunItem, "value", $$v)
                                      },
                                      expression: "sunItem.value",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("%"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { offset: 2, span: 2 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("caozuo") } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: [
                                          "roleManager:rewardSetting:delete",
                                        ],
                                        expression:
                                          "['roleManager:rewardSetting:delete']",
                                      },
                                    ],
                                    attrs: { type: "danger", plain: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteItem(
                                          sunItem,
                                          sunIndex,
                                          "czljjeList1"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("deletetext")) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-row",
                    _vm._l(_vm.showList2, function (item, index) {
                      return _c(
                        "el-col",
                        {
                          key: index,
                          attrs: {
                            span: (index + 1) % 2 == 0 ? 12 : 11,
                            offset: (index + 1) % 2 == 0 ? 1 : 0,
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.setName(item.key) } },
                            [
                              _vm.inputList.includes(item.key)
                                ? _c("el-input", {
                                    model: {
                                      value: item.value,
                                      callback: function ($$v) {
                                        _vm.$set(item, "value", $$v)
                                      },
                                      expression: "item.value",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.orList.includes(item.key)
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: { placeholder: _vm.$t("qxz") },
                                          model: {
                                            value: item.status,
                                            callback: function ($$v) {
                                              _vm.$set(item, "status", $$v)
                                            },
                                            expression: "item.status",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("kaiqi"),
                                              value: 1,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("guanbi"),
                                              value: 0,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.czzsms2.includes(item.key)
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: { placeholder: _vm.$t("qxz") },
                                          model: {
                                            value: item.value,
                                            callback: function ($$v) {
                                              _vm.$set(item, "value", $$v)
                                            },
                                            expression: "item.value",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("dcje"),
                                              value: _vm.$t("dcje"),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("ljje"),
                                              value: _vm.$t("ljje"),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "margin_bottom_12" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["roleManager:rewardSetting:add"],
                              expression: "['roleManager:rewardSetting:add']",
                            },
                          ],
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.addItem("czljjeList2")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("tjqtbl")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.czljjeList2, function (sunItem, sunIndex) {
                    return _c(
                      "el-row",
                      { key: sunIndex },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 9 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("zsjedydy") } },
                              [
                                _c(
                                  "el-input",
                                  {
                                    model: {
                                      value: sunItem.condition,
                                      callback: function ($$v) {
                                        _vm.$set(sunItem, "condition", $$v)
                                      },
                                      expression: "sunItem.condition",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("%"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 9, offset: 1 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("zsjebfb") } },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: { type: "number", max: 100 },
                                    model: {
                                      value: sunItem.value,
                                      callback: function ($$v) {
                                        _vm.$set(sunItem, "value", $$v)
                                      },
                                      expression: "sunItem.value",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("%"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { offset: 2, span: 2 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("caozuo") } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: [
                                          "roleManager:rewardSetting:delete",
                                        ],
                                        expression:
                                          "['roleManager:rewardSetting:delete']",
                                      },
                                    ],
                                    attrs: { type: "danger", plain: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteItem(
                                          sunItem,
                                          sunIndex,
                                          "czljjeList2"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("deletetext")) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog-footer flex-end" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["roleManager:rewardSetting:save"],
                      expression: "['roleManager:rewardSetting:save']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("bcsz")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }